import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MenuModule } from 'primeng/menu';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToolbarModule } from 'primeng/toolbar';

// Composants
import { AssistantPanelService } from 'src/app/@core/services/ai/assistant-panel.service';
import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import { OrganizationsSelectorDialogComponent } from 'src/app/home/components/organizations/organizations-selector-dialog/organizations-selector-dialog.component';
import { QrLoginDialogComponent } from 'src/app/@shared/components/qr-login/qr-login-dialog/qr-login-dialog.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';
import { Tooltip } from "primeng/tooltip";

@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        RouterModule,
        AvatarModule,
        ButtonModule,
        DividerModule,
        MenuModule,
        MessageModule,
        ToolbarModule,
        Tooltip
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Vue
     ----------------------------------------------------------------------------------------*/

    // Menu
    userMenuItems: MenuItem[] = [];

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    client?: Client;

    assistantPanelService = inject(AssistantPanelService);

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onClickAssistant(): void {
        // Ouvre ou ferme le panneau ; sur la page pleine largeur, ramène à l'écran d'où l'on vient
        if (this.assistantPanelService.fullPage) {
            this.assistantPanelService.reduce();
        } else {
            this.assistantPanelService.toggle();
        }
    }

    public logout() {
        this.userService.logout$()
            .subscribe(() => {
                this.router.navigate(['/login']);
            })
    }

    public onClickLogo(): void {
        if (this.appService.selectedClient) {
            this.appService.navToDashboard();
        } else {
            this.router.navigate(['/home']);
        }
    }

    public onClickOrganizationSelector(): void {
        this.openDialog(OrganizationsSelectorDialogComponent, 'ORGANIZATIONS_SELECTOR');
    }

    public onClickTheme(): void {
        this._switchTheme();
    }

    public onStopProfileSimulation(): void {
        this.router.navigate([this.appService.clientUrl('/settings/roles'), this.appService.user?.simulatedProfile?.id]);
        this.appService.user?.stopProfileSimulation();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    override ngOnInit() {
        this._initMenuItems();
        super.ngOnInit();
    }

    protected override subscribeToObservables(): void {
        // Organisation sélectionnée
        this.subscriptions.add(
            this.clientService.selected$.subscribe(
                (client: Client | undefined) => {
                    this.clearAllServicesCache();
                    this.client = client;
                }
            )
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _initMenuItems() {
        this.userMenuItems = [
            {
                icon: PrimeIcons.USER,
                label: 'Voir mon profil',
                routerLink: ['/user']
            },
            { separator: true },
            {
                icon: PrimeIcons.QRCODE,
                label: 'Connexion app Biifor',
                command: () => this._showQrLogin()
            },
            { separator: true },
            {
                icon: PrimeIcons.POWER_OFF,
                label: 'Déconnexion',
                command: () => this.logout()
            },
        ]
    }

    private _showQrLogin(): void {
        this.openDialog(QrLoginDialogComponent, 'QR_LOGIN_DIALOG');
    }

    private _switchTheme(): void {
        this.appService.switchTheme();
    }

}
